module.exports = __webpack_public_path__ + "assets/blue.54aae22f.svg";